import { Tag, Tooltip, theme } from "antd";
import { CSSProperties } from "react";
import { getContrastTextColor } from "src/utils/color";

// Helper function to get color based on score
const getScoreColor = (score: number): string => {
  if (score >= 90) return "#52c41a"; // Green
  if (score >= 70) return "#1890ff"; // Blue
  if (score >= 50) return "#faad14"; // Gold
  if (score >= 30) return "#fa8c16"; // Orange
  return "#f5222d"; // Red
};

export interface ScoreIndicatorProps {
  value: number;
  size?: "small" | "default" | "large";
  showLabel?: boolean;
  tooltip?: string;
  className?: string;
  style?: CSSProperties;
}

export const ScoreIndicator: React.FC<ScoreIndicatorProps> = ({
  value,
  size = "default",
  showLabel = true,
  tooltip,
  className,
  style,
}) => {
  const { token } = theme.useToken();

  // Ensure value is between 0 and 100
  const normalizedValue = Math.max(0, Math.min(100, value));
  const tagColor = getScoreColor(normalizedValue);
  const textColor = getContrastTextColor(tagColor);

  const indicator = (
    <Tag
      className={className}
      style={{
        backgroundColor: tagColor,
        color: textColor,
        border: "none",
        fontSize: size === "small" ? 12 : size === "large" ? 16 : 14,
        padding:
          size === "small"
            ? "0 8px"
            : size === "large"
            ? "4px 16px"
            : "2px 12px",
        borderRadius: token.borderRadiusLG,
        ...style,
      }}
    >
      {showLabel ? `${Math.round(normalizedValue)}` : ""}
    </Tag>
  );

  if (tooltip) {
    return <Tooltip title={tooltip}>{indicator}</Tooltip>;
  }

  return indicator;
};
